import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

export default function Alertas() {
  const [estado, setEstado] = useState("abierta");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => api.get("/alertas", { params: { estado } }).then(({ data }) => setRows(data)).catch((e) => toast.error(formatApiError(e)));
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 30000);
    return () => clearInterval(t);
  }, [estado]);
  return (
    <div className="space-y-6" data-testid="alertas-page">
      <header>
        <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500 font-semibold">Avisos</div>
        <h1 className="font-manrope font-black tracking-tight text-4xl mt-1 flex items-center gap-3"><AlertTriangle className="w-8 h-8 text-red-600" /> Alertas</h1>
        <p className="text-zinc-500 mt-2 text-sm">Se crean y se resuelven solas: por ejemplo, cuando un pedido no tiene bases disponibles.</p>
      </header>
      <div className="flex gap-2">
        {[["abierta", "Abiertas"], ["todas", "Todas"]].map(([v, l]) => (
          <button key={v} onClick={() => setEstado(v)} className={`px-3 py-1.5 text-sm rounded-md border ${estado === v ? "bg-zinc-900 text-white border-zinc-900" : "border-zinc-300"}`} data-testid={`alertas-filtro-${v}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-2" data-testid="alertas-lista">
        {rows === null && <div className="text-sm text-zinc-500">Cargando…</div>}
        {rows?.length === 0 && <div className="text-sm text-zinc-400 border border-zinc-200 rounded-md p-6 bg-white">Sin alertas.</div>}
        {rows?.map((a) => (
          <div key={a.id} className={`flex items-start gap-3 border rounded-md p-3 bg-white ${a.estado === "abierta" ? "border-red-300" : "border-zinc-200 opacity-70"}`} data-testid={`alerta-${a.pedido}`}>
            {a.estado === "abierta" ? <AlertTriangle className="w-5 h-5 text-red-600 shrink-0" /> : <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" />}
            <div className="flex-1"><div className="text-sm font-semibold">{a.mensaje}</div><div className="text-xs text-zinc-500">{a.modulo} · {a.fecha} · {a.estado === "abierta" ? "Abierta" : "Resuelta"}</div></div>
          </div>
        ))}
      </div>
    </div>
  );
}
